export const DOCUMENT_TYPE = {
  VET_NOTES: 'Vet Notes',
  INVOICE: 'Invoice',
  PDS: 'Product Disclosure Statement (PDS)',
  COI: 'Certificate of Insurance (COI)',
  TERMS_OF_USE: 'Terms of Use',
  POLICY_BOOKLET: 'Policy Booklet',
  CRUCIATE_FORM: 'Cruciate Form',
  PRE_EXISTING_EXCLUSION: 'Pre-Existing Exclusion Review Form',
  PRE_AUTHORISATION_FORM: 'Pre-Authorisation Form',
  OTHER: 'Other'
};

export const ELEMENT_INTERACTION_EVENT_NAME = 'element_interaction';

export const DROPPED_INTERACTION_EVENT_TYPES = ['input', 'keyup', 'scroll'];

export const INNERTEXT_MAX_LENGTH = 100;

export const PII_MARKERS = {
  EMAIL: '[EMAIL]',
  CARD: '[CARD]',
  BSB: '[BSB]',
  PHONE: '[PHONE]',
  NAME: '[NAME]'
};

export const PII_PATTERNS = {
  EMAIL: /\b[\w.!#$%&'*+/=?^`{|}~-]+@[\w-]+\.[\w.-]+\b/g,
  CARD_CANDIDATE: /\b\d(?:[ -]?\d){12,18}\b/g,
  BSB: /\b\d{3}-\d{3}\b/g,
  PHONE_AU: /(?:\+61[\s-]?[2-478]|\b0[2-478]|\(0[2-478]\))(?:[\s-]?\d){8}\b/g
};
